import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import "../../assets/css/login.css"
import {
    Row,
    Col,
    CardBody,
    Card,
    Alert,
    Container,
    Form,
    Input,
    FormFeedback,
    Label,
    InputGroup,
    InputGroupText,
} from "reactstrap";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Eye, EyeOff } from "lucide-react";
import { CheckLogin } from "../../api/loginService";
import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import loginBg from '../../assets/images/login_reg/login_bg.jpg';
import { useContext } from "react";
import AuthContext from "../../Context/AuthContext";


//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
import { loginUser, socialLogin } from "../../store/actions";

//Import config
// import { facebook, google } from "../../config";

import { createSelector } from "reselect";

const Login = (props) => {
    document.title = "Login";

    const [showPassword, setShowPassword] = useState(false);
    const { login } = useContext(AuthContext);



    const dispatch = useDispatch();

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            //email: "admin@0.com" || "",
            //password: "123456" || "",

            usernameOrEmail: "",
            password: "",
        },
        validationSchema: Yup.object({
            usernameOrEmail: Yup.string().required("Please enter your Username or Email"),
            password: Yup.string().required("Please enter your Password"),
        }),
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const loginRequest = {
                    Username: values.usernameOrEmail,
                    Password: values.password
                };

                const response = await CheckLogin(loginRequest);
                console.log("Login API Response:", response);

                if (response?.Message?.[0]?.RETURNCODE === "1") {
                    const jwtToken = response?.UserDetail?.[0]?.JWTTOKEN;
                    const loginUserData = response?.UserDetail?.[0];

                    if (jwtToken) {

                        localStorage.setItem("authToken", jwtToken);
                        localStorage.setItem("authUser", JSON.stringify(loginUserData));
                        localStorage.removeItem("LOGGED_OUT");
                    }

                    const salesPersonNumber = response?.ROW?.[0]?.SALESPERSON_MOBILE; 

                    if (salesPersonNumber) {
                        localStorage.setItem("salesPersonWA", salesPersonNumber);
                        console.log("salesPersonNumber", salesPersonNumber)
                    }

                    const userData = {
                        LEDGER_ID: response?.UserDetail?.[0]?.LEDGER_ID || "some-unique-id", // must exist
                        TOKEN: jwtToken,
                        COMPANYLOGO: response?.UserDetail?.[0]?.COMPANYLOGO || null,
                        COMPANYNAME: response?.UserDetail?.[0]?.COMPANYNAME || "MJH",
                        USERNAME: response?.UserDetail?.[0]?.USERNAME || ""
                    };

                    // Update AuthContext
                    login(userData);


                    toast.success(response.Message[0].RETURNMESSAGE || "Login successful!");
                    setTimeout(() => {
                        props.router.navigate("/bin-stock");
                    }, 3000);
                } else {
                    toast.error(response?.Message?.[0]?.RETURNMESSAGE || "Login failed");
                }
            } catch (error) {
                console.error("Login API Error:", error);
                toast.error("Login failed. Please try again.");
            } finally {
                setSubmitting(false);
            }
        },

    });

    const loginpage = createSelector(
        (state) => state.login,
        (state) => ({
            error: state.error,
        })
    );
    // Inside your component
    const { error } = useSelector(loginpage);

    // handleValidSubmit
    // const handleValidSubmit = (event, values) => {
    //   dispatch(loginUser(values, props.router.navigate));
    // };

    // const signIn = (res, type) => {
    //   if (type === "google" && res) {
    //     const postData = {
    //       name: res.profileObj.name,
    //       email: res.profileObj.email,
    //       token: res.tokenObj.access_token,
    //       idToken: res.tokenId,
    //     };
    //     dispatch(socialLogin(postData, props.router.navigate, type));
    //   } else if (type === "facebook" && res) {
    //     const postData = {
    //       name: res.name,
    //       email: res.email,
    //       token: res.accessToken,
    //       idToken: res.tokenId,
    //     };
    //     dispatch(socialLogin(postData, props.router.navigate, type));
    //   }
    // };

    const signIn = (type) => {
        dispatch(socialLogin(type, props.router.navigate));
    };

    //for facebook and google authentication
    const socialResponse = (type) => {
        signIn(type);
    };

    useEffect(() => {
        document.body.className = "bg-pattern";
        // remove classname when component will unmount
        return function cleanup() {
            document.body.className = "";
        };
    });

    return (
        <React.Fragment>
            <div className="account-pages login-background py-5"
                style={{
                    backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${loginBg})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    draggable
                    theme="colored"
                />
                <></>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6} md={8} xl={4}>
                            <Card className="mb-0">
                                <CardBody className="p-4" style={{ background: "#fff" }}>
                                    <div>
                                        <div className="text-center ">
                                            <Link to="/">
                                                <img
                                                    src="assets/images/Logo/Logo_dark.png" alt="Logo"
                                                    height="40"
                                                    style={{ filter: 'none' }}
                                                />
                                            </Link>
                                        </div>
                                        <h4 className="font-size-18 text-muted mt-2 text-center">
                                            Welcome Back !
                                        </h4>
                                        <p className="mb-5 text-center">
                                            Sign in to continue to MJH.
                                        </p>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            {error ? (
                                                <Alert color="danger">
                                                    <div>{error}</div>
                                                </Alert>
                                            ) : null}
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-4">
                                                        <Label htmlFor="usernameOrEmail" className="form-label">Username or Email</Label>
                                                        <Input
                                                            id="usernameOrEmail"
                                                            name="usernameOrEmail"
                                                            className="form-control"
                                                            placeholder="Enter Username or Email"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.usernameOrEmail || ""}
                                                            invalid={validation.touched.usernameOrEmail && !!validation.errors.usernameOrEmail}
                                                        />
                                                        {validation.touched.usernameOrEmail && validation.errors.usernameOrEmail && (
                                                            <FormFeedback>{validation.errors.usernameOrEmail}</FormFeedback>
                                                        )}
                                                    </div>
                                                    <div className="mb-4">
                                                        <Label htmlFor="password" className="form-label">Password</Label>
                                                        <InputGroup>
                                                            <Input
                                                                id="password"
                                                                className="form-control"
                                                                name="password"
                                                                type={showPassword ? "text" : "password"}
                                                                placeholder="Enter Password"
                                                                value={validation.values.password || ""}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                invalid={validation.touched.password && !!validation.errors.password}
                                                            />
                                                            <InputGroupText
                                                                onClick={() => setShowPassword(!showPassword)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    backgroundColor: "#f3f3f4",
                                                                    borderLeft: "none",
                                                                }}
                                                            >
                                                                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                                            </InputGroupText>
                                                            {validation.touched.password && validation.errors.password && (
                                                                <FormFeedback>{validation.errors.password}</FormFeedback>
                                                            )}
                                                        </InputGroup>
                                                    </div>

                                                    <Row>
                                                        <Col md="6">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="customControlInline"
                                                                />
                                                                <label
                                                                    className="form-label"
                                                                    htmlFor="customControlInline"
                                                                >
                                                                    Remember me
                                                                </label>
                                                            </div>
                                                        </Col>
                                                        <Col md="6">
                                                            <div className=" mt-3 mt-md-0">
                                                                <Link
                                                                    to="/forget-password"
                                                                    className="text-muted d-flex"
                                                                >
                                                                    <i className="mdi mdi-lock"></i> Forgot your
                                                                    password?
                                                                </Link>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <div className="d-grid mt-4">
                                                        <button
                                                            className="btn btn-primary waves-effect waves-light"
                                                            type="submit"
                                                        >
                                                            Log In
                                                        </button>
                                                    </div>
                                                    <div className="mt-4 text-center">
                                                        <h5 className="font-size-14 mb-3 ">
                                                            <Link to="/register" className="text-primary ">
                                                                Register
                                                            </Link>
                                                        </h5>


                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);

Login.propTypes = {
    history: PropTypes.object,
};
